module.exports = __webpack_public_path__ + "367a7ae911acd85a78e7359e5ce3cddb.png";